
import AzBreadcrumbs from '~/components/_next/atoms/AzBreadcrumbs.vue';
import type { PropType } from 'vue';
import type { Breadcrumb } from '~/types/_next/ui';

export default {
  name: 'BaseBreadcrumbs',
  components: {
    AzBreadcrumbs,
  },
  props: {
    breadcrumbs: {
      type: [] as PropType<Breadcrumb[]>,
      default: () => [],
    },
  },
};
